// Actions types
export const SET_RESERVAS = "SET_RESERVAS";
export const SET_MIS_RESERVAS = "SET_MIS_RESERVAS";
export const SET_SLOTS_DISPONIBLES = "SET_SLOTS_DISPONIBLES";
export const SET_CANCHAS_DISPONIBILIDAD = "SET_CANCHAS_DISPONIBILIDAD";
export const SET_BLOQUEOS = "SET_BLOQUEOS";
export const SET_CANCHA_SELECCIONADA = "SET_CANCHA_SELECCIONADA";
export const SET_FECHA_SELECCIONADA = "SET_FECHA_SELECCIONADA";
export const SET_SOCIOS = "SET_SOCIOS";
export const SET_LOADING_SOCIOS = "SET_LOADING_SOCIOS";
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";
export const ADD_RESERVA = "ADD_RESERVA";
export const UPDATE_RESERVA = "UPDATE_RESERVA";
export const DELETE_RESERVA = "DELETE_RESERVA";
